// Presence beats: tell the server this tab is actually VISIBLE (not merely connected).
// Server-side, OS-push suppression keys off *active* presence (a visible beat within the
// last 2 minutes) — so a chat tab left in the background of an awake PC no longer swallows
// @all/mention phone notifications, while someone actively looking at the app still isn't
// spammed on their phone. Beats fire immediately, on tab visibility changes, on reconnect,
// and every minute while visible. Returns an unwire function.
export function wirePresenceBeats(conn) {
  const beat = () => {
    if (document.visibilityState === "visible" && conn.state === "Connected")
      conn.invoke("PresenceVisible").catch(() => { /* reconnecting — the next beat lands */ });
  };
  const timer = setInterval(beat, 60000);
  document.addEventListener("visibilitychange", beat);
  conn.onreconnected(beat); // a new server instance starts with empty presence — re-assert
  beat();
  return () => {
    clearInterval(timer);
    document.removeEventListener("visibilitychange", beat);
  };
}
